import { usePage } from '@inertiajs/react'
import { type ReactElement } from 'react'
import type { SharedData } from '@/types/shared'

export function FlashBanner (): ReactElement | null {
  const { flash } = usePage<SharedData>().props

  if (flash == null) return null

  return (
    <>
      {(flash.notice != null && flash.notice !== '') && (
        <div
          style={{
            background: 'var(--bp-ok-pale)',
            border: '1px solid var(--bp-ok-border)',
            borderRadius: 8,
            padding: '12px 16px',
            marginBottom: 16,
            color: 'var(--bp-ok)',
            fontSize: 13
          }}
        >
          {flash.notice}
        </div>
      )}
      {(flash.alert != null && flash.alert !== '') && (
        <div
          style={{
            background: 'var(--bp-critical-pale)',
            border: '1px solid var(--bp-critical-border)',
            borderRadius: 8,
            padding: '12px 16px',
            marginBottom: 16,
            color: 'var(--bp-critical)',
            fontSize: 13
          }}
        >
          {flash.alert}
        </div>
      )}
    </>
  )
}
